import { ShowMoreItemsWebComponent } from './component/ShowMoreItemsWebComponent';

export { ShowMoreItemsWebComponent };
export const SHOW_MORE_ITEMS_EVENT = 'showMoreItems';
